import { useEffect } from 'react';
import type { SemanticAnalysisStatus, SemanticFramework } from '../../../services/semanticService';

export const useSemanticAnalysisData = (
  semanticAnalysisStatusQuery: any,
  analysisStatusQuery: any,
  isAnalyzing: boolean,
  setIsAnalyzing: (value: boolean) => void,
  setAnalysisStatus: (status: SemanticAnalysisStatus | null) => void,
  setAnalysisId: (id: string | null) => void,
  setSelectedFramework: (framework: SemanticFramework | null) => void,
  selectedFramework: SemanticFramework | null,
  setError: (error: string | null) => void,
  workflowData: any,
  updateWorkflowData: (data: any) => void,
  workflowId: string | null | undefined,
  clientId: string,
  triggerRefresh?: () => void
) => {
  // Effect to handle semantic analysis status updates via workflow ID
  useEffect(() => {
    if (semanticAnalysisStatusQuery.data) {
      const statusData = semanticAnalysisStatusQuery.data;
      console.log('Semantic analysis workflow status update:', statusData);
      
      if (statusData) {
        setAnalysisStatus(statusData);
        
        // If we have a completed analysis with a framework ID, load it
        if (statusData.status === 'completed' && statusData.semantic_framework && !selectedFramework) {
          setSelectedFramework(statusData.semantic_framework);
          // Persist framework to localStorage
          if (workflowId) {
            localStorage.setItem(`module3_${workflowId}_framework`, JSON.stringify(statusData.semantic_framework));
          }
          
          // Trigger refresh to update stepper status
          if (triggerRefresh) {
            triggerRefresh();
          }
        }
        
        // If the analysis is in progress, set the analyzing state
        if (statusData.status === 'queued' || statusData.status === 'processing') {
          setIsAnalyzing(true);
          // If we have an analysis ID, set it to enable detailed polling
          if (statusData.analysis_id) {
            setAnalysisId(statusData.analysis_id);
          }
        }
      }
    }
  }, [semanticAnalysisStatusQuery.data, selectedFramework, setAnalysisId, setAnalysisStatus, setIsAnalyzing, setSelectedFramework, triggerRefresh, workflowId]);
  
  // Check for existing semantic results in workflowData when component loads
  
  // Effect to handle semantic analysis status updates via analysis ID
  useEffect(() => {
    if (analysisStatusQuery.data && isAnalyzing) {
      const statusData = analysisStatusQuery.data;
      console.log('Semantic analysis status update:', statusData);
      
      if (statusData) {
        setAnalysisStatus(statusData);
        
        // If the analysis is completed or failed, stop analyzing
        if (statusData.status === 'completed' || statusData.status === 'failed') {
          console.log("Semantic analysis completed", statusData.semantic_framework);
          setIsAnalyzing(false);
          
          if (statusData.status === 'failed') {
            setError(statusData.message || 'Analysis failed');
          }
          
          // If we have a completed analysis with a framework ID, load it
          if (statusData.status === 'completed' && statusData.semantic_framework) {
            setSelectedFramework(statusData.semantic_framework);
            // Persist framework to localStorage
            if (workflowId) {
              localStorage.setItem(`module3_${workflowId}_framework`, JSON.stringify(statusData.semantic_framework));
            }
            updateWorkflowData({
              ...workflowData,
              semanticResult: statusData.semantic_framework
            });
          }
          
          // Trigger refresh to update stepper status when analysis completes (success or failure)
          if (triggerRefresh) {
            triggerRefresh();
          }
        }
      }
    }
  }, [analysisStatusQuery.data, isAnalyzing, setAnalysisStatus, setError, setIsAnalyzing, setSelectedFramework, updateWorkflowData, workflowData, triggerRefresh, workflowId]);
};

export default useSemanticAnalysisData;
